import { buildScopedI18n } from '../../../utils/buildScopedI18n';
import caseDetailsEsCL from './locales/es-CL.json';
import caseDetailsEnUS from './locales/en-US.json';
import caseDetailsPtBR from './locales/pt-BR.json';

export const caseDetailsI18n = buildScopedI18n({
  esCL: caseDetailsEsCL,
  enUS: caseDetailsEnUS,
  ptBR: caseDetailsPtBR,
});
